export const HEADER_IMAGE_CENTER_Y = 50;

export function clampHeaderImageCropY(cropY: number) {
  return Math.min(100, Math.max(0, Number(cropY.toFixed(2))));
}

export function headerImageCropYAfterDrag({
  startCropY,
  deltaY,
  viewportWidth,
  viewportHeight,
  imageWidth,
  imageHeight,
}: {
  startCropY: number;
  deltaY: number;
  viewportWidth: number;
  viewportHeight: number;
  imageWidth: number;
  imageHeight: number;
}) {
  if (!viewportWidth || !viewportHeight || !imageWidth || !imageHeight) {
    return startCropY;
  }

  const scale = Math.max(
    viewportWidth / imageWidth,
    viewportHeight / imageHeight
  );
  const overflowY = Math.max(0, imageHeight * scale - viewportHeight);

  return clampHeaderImageCropY(
    overflowY === 0 ? startCropY : startCropY - (deltaY / overflowY) * 100
  );
}

export function headerImageCropYFromLegacyPosition(
  imageTop: number,
  imageHeight: number,
  viewportTop: number,
  viewportHeight: number
) {
  const overflowY = imageHeight - viewportHeight;
  if (overflowY <= 0) return HEADER_IMAGE_CENTER_Y;

  return clampHeaderImageCropY(((viewportTop - imageTop) / overflowY) * 100);
}
